import {changeLoginAction} from '../../ducks/duck-user';
import {getTranslation} from "../get-translation";
import {
    changeScreen,
    EXTRA_SCREEN,
    GAME_SCREEN,
    HINTS_SCREEN,
    LOGIN_SCREEN,
    LOGOS_SCREEN,
    MAIN_SCREEN,
    PLAY_SCREEN,
    RANKING_SCREEN,
    SETTINGS_SCREEN,
    STATISTICS_SCREEN,
} from '../../ducks/duck-screen'
import LOGIN_EMAIL_ACTIONS from "../../constants/LOGIN_EMAIL_ACTIONS";

const pathMap = {};
const url = getTranslation("url");

export function getPath(screen = ""){
	if(pathMap[screen]){
		return pathMap[screen]
	}
	if(process.env.NODE_ENV === "development" || window.location.hostname === "logo-quiz.akjaw.com") {
		pathMap[screen] = '/' + screen
	} else {
		pathMap[screen] = '/' + url + '/' + screen
	}

	return pathMap[screen]
}

export function createLocationListener(store){
	let nextLocation = store.getState().routerReducer.pathname;
	let locationList = [getPath("")];

	return function locationListener() {
		let previousLocation = nextLocation;
		nextLocation = store.getState().routerReducer.pathname;

		if (previousLocation !== nextLocation) {
			// console.log('subscribe', previousLocation, nextLocation)
			// debugger;
			locationList.push(nextLocation);
			const length = locationList.length;
			// console.log('prev', previousLocation);
			// console.log('locationList', locationList);
			// debugger;
			if(locationList[length - 1] === getPath("")){//Wszystkie powroty do main screen
				if(
					previousLocation === getPath(STATISTICS_SCREEN) ||
					previousLocation === getPath(SETTINGS_SCREEN) ||
					previousLocation === getPath(RANKING_SCREEN) ||
					previousLocation === getPath(HINTS_SCREEN) ||
					previousLocation === getPath(EXTRA_SCREEN) ||
					previousLocation === getPath(PLAY_SCREEN)
				) {
					store.dispatch(changeScreen(MAIN_SCREEN));
					locationList = [getPath("")];
				}
			} else if (locationList[length - 2] === getPath("")){//Wszystkie przejścia z main screen
				let latestLocation;
				if(process.env.NODE_ENV === "development") {
					latestLocation = locationList[length - 1].substring(1)
				} else {
					latestLocation = locationList[length - 1].replace("/" + url, "").replace("/", "");
				}
				store.dispatch(changeScreen(latestLocation));
			} else if (locationList[length - 2] === getPath(PLAY_SCREEN)){ //Wszystkie przejścia z play screen

				if(locationList[length - 1] === getPath(LOGOS_SCREEN)){
					store.dispatch(changeScreen(LOGOS_SCREEN))

				} else if(locationList[length - 1] === getPath(EXTRA_SCREEN)){
					store.dispatch(changeScreen(EXTRA_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(LOGOS_SCREEN)) { //Wszystkie przejścia z logo screen

				if(locationList[length - 1] === getPath(PLAY_SCREEN)){ //Jeśli cofamy na play screen
					locationList.splice(length - 2, 2);
					store.dispatch(changeScreen(PLAY_SCREEN));

				} else if (locationList[length - 1] === getPath(GAME_SCREEN)){ //Jeśli przechodzimy na game screen
					store.dispatch(changeScreen(GAME_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(GAME_SCREEN)) { //Wszystkie przejścia z game screen

				if(locationList[length - 1] === getPath(LOGOS_SCREEN)){ //Jeśli cofamy na logo screen

					locationList.splice(length - 2, 2);//TO robi cokolwiek?
					store.dispatch(changeScreen(LOGOS_SCREEN));

				} else if(locationList[length - 1] === getPath(EXTRA_SCREEN)){ //Jeśli klikamy w modal odblokowania extra level
					store.dispatch(changeScreen(EXTRA_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(EXTRA_SCREEN)){ //Wszystkie przejścia z extra screen

				if(locationList[length - 1] === getPath(PLAY_SCREEN)){ //Jeśli z extra wybierzemy extra level
					store.dispatch(changeScreen(PLAY_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(SETTINGS_SCREEN)){ //Wszystkie przejścia z settings screen

				if(locationList[length - 1] === getPath(LOGIN_SCREEN)){ //Jeśli nacisniemy Log in w ustawieniach

					store.dispatch(changeScreen(LOGIN_SCREEN));

				} else if(locationList[length - 1] === getPath(STATISTICS_SCREEN)){ //Jeśli nacisniemy w Statiscics

					store.dispatch(changeScreen(STATISTICS_SCREEN));

				} else if(locationList[length - 1] === getPath(RANKING_SCREEN)){ //Jeśli nacisniemy w Hight scroes

					store.dispatch(changeScreen(RANKING_SCREEN));

				}

			} else if (locationList[length - 2] === getPath(LOGIN_SCREEN)){ //Wszystkie przejścia z login screen

				if(locationList[length - 1] === getPath(SETTINGS_SCREEN)){
					store.dispatch(changeScreen(SETTINGS_SCREEN));

				} else if(locationList[length - 1] === getPath(LOGIN_EMAIL_ACTIONS.LOGIN)){ //Jeśli przechodzimy do logowania mailowego
					store.dispatch(changeScreen(LOGIN_EMAIL_ACTIONS.LOGIN));
				}

			} else if (locationList[length - 2] === getPath(LOGIN_EMAIL_ACTIONS.LOGIN)){ //Wszystkie przejścia z logowania mailowego

				if(locationList[length - 1] === getPath(LOGIN_EMAIL_ACTIONS.REGISTER)){ //Naciskamy Utwórz konto
					store.dispatch(changeLoginAction(LOGIN_EMAIL_ACTIONS.REGISTER));

				} else if(locationList[length - 1] === getPath(LOGIN_EMAIL_ACTIONS.RESET)){ //Zapomniałem hasłá
					store.dispatch(changeLoginAction(LOGIN_EMAIL_ACTIONS.RESET));

				} else if(locationList[length - 1] === getPath(LOGIN_SCREEN)){  //cofamy do logowania sociali
					store.dispatch(changeScreen(LOGIN_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(LOGIN_EMAIL_ACTIONS.REGISTER)){ //Wszystkie przejścia z rejestracji mailowej

				if(locationList[length - 1] === getPath(LOGIN_EMAIL_ACTIONS.LOGIN)){ //Cofamy na login
					locationList.splice(length - 2, 2);
					store.dispatch(changeLoginAction(LOGIN_EMAIL_ACTIONS.LOGIN));
				}

			} else if (locationList[length - 2] === getPath(LOGIN_EMAIL_ACTIONS.RESET)){ //Wszystkie przejścia z resetu hasła email

				if(locationList[length - 1] === getPath(LOGIN_EMAIL_ACTIONS.LOGIN)){ //Cofamy na login
					locationList.splice(length - 2, 2);
					store.dispatch(changeLoginAction(LOGIN_EMAIL_ACTIONS.LOGIN));
				}

			} else if (locationList[length - 2] === getPath(STATISTICS_SCREEN)){ //Wszystkie przejścia z ekranu statystyk

				if(locationList[length - 1] === getPath(SETTINGS_SCREEN)){ //Cofamy na ekran statystyk
					store.dispatch(changeScreen(SETTINGS_SCREEN));
				}

			} else if (locationList[length - 2] === getPath(RANKING_SCREEN)){ //Wszystkie przejścia z ekranu rankingu

				if(locationList[length - 1] === getPath(SETTINGS_SCREEN)){ //Cofamy na ekran statystyk
					store.dispatch(changeScreen(SETTINGS_SCREEN));
				}
			}
		}
	}

}
